<template>
  <v-card class="my-3">
    <v-card-title primary-title style="display: block">
      <h3 v-t="'settingsContainer.appearance'" class="headline">Appearance</h3>
      <span v-t="'settingsContainer.appearanceSubtitle'" />
    </v-card-title>
    <v-list>
      <color-row v-for="item in items" :key="item.name" :item="item" @newColor="onColorUpdate($event, item.color)" />
    </v-list>
    <v-card-actions>
      <v-btn flat color="primary" :disabled="!dirty" @click="saveColors"><span v-t="'common.save'" /></v-btn>
      <v-btn flat @click="resetColors"><span v-t="'common.reset'" /></v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import StorageService from '@/services/StorageService';
import ColorRow from './ColorRow.vue';

export default {
  name: 'SettingsContainer',
  components: {
    'color-row': ColorRow,
  },
  data() {
    return {
      dirty: false,
      defaultTheme: {
        primary: '#525D6D',
        secondary: '#E27824',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    };
  },
  computed: {
    items() {
      return [{
        name: 'settingsContainer.primary',
        color: 'primary',
        hex: this.$vuetify.theme.primary,
      }, {
        name: 'settingsContainer.secondary',
        color: 'secondary',
        hex: this.$vuetify.theme.secondary,
      }, {
        name: 'settingsContainer.info',
        color: 'info',
        hex: this.$vuetify.theme.info,
      }, {
        name: 'settingsContainer.error',
        color: 'error',
        hex: this.$vuetify.theme.error,
      }];
    },
  },
  methods: {
    onColorUpdate(newColor, item) {
      this.$vuetify.theme[item] = newColor;
      this.dirty = true;
    },
    saveColors() {
      StorageService.add('theme', JSON.stringify(this.$vuetify.theme));
      this.dirty = false;
    },
    resetColors() {
      StorageService.add('theme', JSON.stringify(this.defaultTheme));
      this.$vuetify.theme = JSON.parse(StorageService.get('theme', JSON.stringify(this.defaultTheme)));
      this.dirty = false;
      this.$forceUpdate();
    },
  },
};
</script>
